import { useQuery } from '@tanstack/react-query';
import { DurationLike } from 'luxon/src/duration';

import { getCampaignsSalesAndOrders } from 'apis/merchant-gateway/insights/campaigns-performance/sales/api';
import { CampaignOrdersAndSales } from 'apis/merchant-gateway/insights/campaigns-performance/sales/types';
import { AnalyticsAPICampaignType } from 'apis/merchant-gateway/insights/campaigns-performance/types';
import { CampaignType } from 'apis/restaurant-api/merchant-admin/campaigns/types';
import { EntityType } from 'common/types';

import { CampaignListItem } from '../types';

export const useSalesAndOrders = ({
  entityType,
  entityId,
  campaignsList,
  duration = { months: 6 },
}: {
  entityType: Extract<EntityType, 'venue' | 'merchant'>;
  entityId: string;
  campaignsList: CampaignListItem[];
  duration?: DurationLike;
}) =>
  useQuery(
    [
      'insights/campaigns-performance/sales',
      entityType,
      entityId,
      duration,
      ...campaignsList.map(campaign => campaign.campaignId),
    ],
    () =>
      getCampaignsSalesAndOrders(
        entityType,
        entityId,
        campaignsList.map(campaign => ({
          campaignId: campaign.campaignId,
          campaignType:
            campaign.campaignType === CampaignType.ADS
              ? AnalyticsAPICampaignType.AD
              : AnalyticsAPICampaignType.PROMOTION,
        })),
        duration,
      ),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: 24 * 60 * 60 * 1000, // 24h
      enabled: campaignsList.length > 0,
      select: data =>
        data.campaigns.reduce<Record<string, CampaignOrdersAndSales>>((acc, campaign) => {
          acc[campaign.campaignId] = campaign;
          return acc;
        }, {}),
    },
  );
